export default __webpack_public_path__ + "img/5fa7f9de81aecea952c9e761f57beb46.svg";